import { render, staticRenderFns } from "./EZUIKitJs.vue?vue&type=template&id=bf3e8e76&scoped=true"
import script from "./EZUIKitJs.vue?vue&type=script&lang=js"
export * from "./EZUIKitJs.vue?vue&type=script&lang=js"
import style0 from "./EZUIKitJs.vue?vue&type=style&index=0&id=bf3e8e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3e8e76",
  null
  
)

export default component.exports